// createRouter:创建router实例对象
// createWebHistory:创建history模式的路由
import { useUserStore } from '@/stores/userStore'
import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login/index.vue'
import Layout from '@/views/Layout/index.vue'
import Home from '@/views/Home/index.vue'
import SubCategory from '@/views/SubCategory/index.vue'
import Detail from '@/views/Detail/index.vue'
import CartList from '@/views/CartList/index.vue'
import Category from '@/views/Category/index.vue'
import Checkout from '@/views/Checkout/index.vue'
// import PayBack from '@/views/Pay/PayBack.vue'
import Member from '@/views/Member/index.vue'
import UserInfo from '@/views/Member/components/UserInfo.vue'
import WalletData from '@/views/Member/components/WalletData.vue'
import CollectData from '@/views/Member/components/CollectData.vue'
import FocusOnData from '@/views/Member/components/FocusOnData.vue'
import FanData from '@/views/Member/components/FanData.vue'
import Webinfo from '@/views/Webinfo/index.vue'
import AboutUs from '@/views/Webinfo/components/AboutUs.vue'
import Pack from '@/views/Webinfo/components/pack.vue'
import ShippingPolicy from '@/views/Webinfo/components/ShippingPolicy.vue'
import termsOfService from '@/views/Webinfo/components/termsOfService.vue'
import paymentMethods from '@/views/Webinfo/components/paymentMethods.vue'
import returnPolicy from '@/views/Webinfo/components/returnPolicy.vue'
import privacyPolicy from '@/views/Webinfo/components/privacyPolicy.vue'
import intellectualPropertyRights from '@/views/Webinfo/components/intellectualPropertyRights.vue'

import historyData from '@/views/Member/components/historyData.vue'
import UserOrder from '@/views/Member/components/UserOrder.vue'
import PublishOrder from '@/views/Member/components/PublishOrder.vue'
import BuyOrder from '@/views/Member/components/BuyOrder.vue'
import MallOrder from '@/views/Member/components/MallOrder.vue'
import Affiliate from '@/views/Member/components/Affiliate.vue'
import PurchasingOrder from '@/views/Member/components/PurchasingOrder.vue'
import SellOrder from '@/views/Member/components/SellOrder.vue'
import publishPage from '@/views/publishPage/index.vue'
import UserDetails from '@/views/Home/components/UserDetails.vue'

import customerService from '@/views/customerService/index.vue'
import setupPage from '@/views/setupPage/index.vue'
import addressPage from '@/views/setupPage/components/addressPage.vue'
import internalPage from '@/views/setupPage/components/internalPage.vue'

import userInfoPage from '@/views/setupPage/components/userInfoPage.vue'
import orderDetails from '@/components/orderDetails/index.vue'
import pay from '@/views/Pay/index.vue'
import externalViews from '@/views/externalDetail/index.vue'
import usdPayment from '@/components/usdPayment/index.vue'
import Payment from '@/views/Payment/index.vue'
import estimation from '@/views/estimation/index.vue'
import estimationDatail from '@/views/estimation/detail.vue'
import CommonTemplate from '@/views/Member/components/CommonTemplate.vue'
import Splash from '@/views/Splash.vue'

const router = createRouter({
    mode: 'history',
    history: createWebHistory(import.meta.env.BASE_URL),
    // path和component对应关系的位置
    routes: [
        {
            path: '/',
            component: Layout,
            children: [

                {
                    path: '',
                    component: Home,
                    meta: {
                        title: '首页',
                        description: '商城首页',
                    },
                },
                {
                    path: "401",
                    component: () => import("@/views/error-page/401.vue"),
                    meta: { hidden: true },
                },
                {
                    path: "404",
                    component: () => import("@/views/error-page/404.vue"),
                    meta: { hidden: true },
                },
                {
                    path: 'userDetails/:id',
                    component: UserDetails,
                    meta: {
                        title: '个人信息',
                        description: '个人信息',
                    },
                },
                // {
                //     path: 'category/:id',
                //     component: Category
                // },
                {
                    path: 'category/sub/:type/:id',
                    component: SubCategory,
                    meta: {
                        title: '商品搜索',
                        description: '商品搜索',
                    },
                },
                {
                    path: 'externals/:from/:product_id',
                    component: externalViews,
                    meta: {
                        title: '1688',
                        description: '1688',
                    },
                },

                {
                    path: 'usdPayment',
                    component: usdPayment,
                    meta: {
                        title: 'usd支付',
                        description: 'usd支付',
                    },
                },
                {
                    path: 'detail/:id',
                    component: Detail,
                    meta: {
                        title: '商品详情',
                        description: '商品详情',
                    },
                },

                {
                    path: 'Category',
                    component: Category,
                    meta: {
                        title: '分类',
                        description: '分类',
                    },
                },
                {
                    path: 'cartlist',
                    component: CartList,
                    meta: {
                        title: '购物车',
                        description: '购物车',
                    },
                },
                {
                    path: 'pay/:redirect',
                    component: pay,
                    meta: {
                        title: '支付成功',
                        description: '支付成功',
                    },

                },
                
                {
                    path: 'estimation',
                    component: estimation,
                    meta: {
                        title: '运费计算',
                        description: '运费计算',
                    },
                },
                {
                    path: 'estimation/detail/:id',
                    component: estimationDatail,
                    meta: {
                        title: '运费详情',
                        description: '运费详情',
                    },
                },
                
                {
                    path: 'checkout',
                    component: Checkout,
                    meta: {
                        title: '提交订单',
                        description: '提交订单',
                    },
                },
                {
                    // path: 'Payment',
                    path: 'Payment',
                    component: Payment,
                    meta: {
                        title: '付款页面',
                        description: '付款页面',
                    },
                },
                {
                    // path: 'Payment',
                    path: 'Payment/:type/:status',
                    component: Payment,
                    meta: {
                        title: '付款页面',
                        description: '付款页面',
                    },
                },
                
                {
                    path: 'customerPage',
                    component: customerService
                },
                {

                    path: 'setup',
                    component: setupPage,
                    meta: {
                        title: '设置',
                        description: '设置',
                    },
                },
                {

                    path: 'address',
                    component: addressPage,
                    meta: {
                        title: '地址',
                        description: '地址',
                    },
                },
                {

                    path: 'userInfoPage',
                    component: userInfoPage
                },
                {
                    path: 'internal',
                    component: internalPage,

                },
                {
                    path: 'orderDetails/:id/:type',
                    component: orderDetails
                },

                {

                    path: 'add',
                    component: publishPage
                },
                {

                    path: 'add/:id',
                    component: publishPage
                },
                {
                    path: 'fan',
                    component: FanData
                },
                {

                    path: 'focusOn',//关注
                    component: FocusOnData
                },
                {

                    path: 'wallet',//钱包
                    component: WalletData
                },
                {
                    path: 'MallOrder',//商城买入
                    component: MallOrder
                },
                {
                    path: 'PurchasingOrder',//代购买入
                    component: PurchasingOrder
                },
                {
                    path: 'collect',//收藏
                    component: CollectData
                }, 
                {
                    path: 'sell',//卖出
                    component: SellOrder
                },

                {
                    path: 'publish',//发布
                    component: PublishOrder,
                    meta: {
                        title: '我发布的商品',
                        description: '我发布的商品',
                    },
                },
                {
                    path: 'member',
                    component: Member,
                    children: [
                        {
                            path: '',
                            component: UserInfo
                        },
                        {
                            path: 'fan',
                            component: FanData
                        },
                        {
                            path: 'address',
                            component: addressPage,
                        },
                        {
                            path: 'CommonTemplate',
                            component: CommonTemplate,
                        },
                        {
                            path: 'affiliate',
                            component: Affiliate,
                        },
                        
                        {
                            path: 'order',
                            component: UserOrder
                        }, {
                            path: 'publish',//发布
                            component: PublishOrder
                        }, {
                            path: 'buy',//买入
                            component: BuyOrder
                        },
                        {
                            path: 'MallOrder',//商城买入
                            component: MallOrder
                        },
                        {
                            path: 'PurchasingOrder',//代购买入
                            component: PurchasingOrder
                        },
                        {
                            path: 'sell',//卖出
                            component: SellOrder
                        }, {

                            path: 'history',//历史
                            component: historyData
                        },
                        {
                            path: 'collect',//收藏
                            component: CollectData
                        }
                        , {

                            path: 'focusOn',//关注
                            component: FocusOnData
                        },
                        // ,{

                        //     path: 'fan',//粉丝
                        //     component: FanOnData
                        // },

                        {
                            path: 'cartlist',
                            component: CartList
                        }

                        , {

                            path: 'wallet',//钱包
                            component: WalletData
                        }
                    ]
                },
                {
                    path: 'webinfo',
                    component: Webinfo,
                    children: [
                        {
                            path: 'aboutUs',
                            component: AboutUs,
                        },
                        {
                            path: 'pack',
                            component: Pack
                        },
                        {
                            path: 'shippingPolicy',
                            component: ShippingPolicy,
                        },

                        {
                            path: 'termsOfService',
                            component: termsOfService
                        }, {
                            path: 'paymentMethods',
                            component: paymentMethods
                        }, {
                            path: 'returnPolicy',
                            component: returnPolicy
                        }, {
                            path: 'privacyPolicy',
                            component: privacyPolicy
                        }, {
                            path: 'intellectualPropertyRights',
                            component: intellectualPropertyRights
                        }
                        
                    ]

                }

            ]
        },
        {
            path: '/splash',
            name: 'Splash',
            component: Splash,
            meta: { requiresStandalone: true }
          },
        {
            path: '/login',
            component: Login,
            meta: {
                title: '登录',
                description: '登录，注册，忘记密码',
            },
        }
    ],
    // 路由滚动行为定制
    scrollBehavior() {
        return {
            top: 0
        }
    }
})
// 添加全局前置守卫
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next(from.name ? { name: from.name } : "/404");
    } else {
        if (to.meta.requiresStandalone) {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            const isFromPWA = new URLSearchParams(window.location.search).has('source=pwa')
            
            if (!isStandalone && !isFromPWA && window.Telegram?.WebApp.initData=="") {
                return next('/') // 不是从桌面启动，跳过启动页
            }
        }
        const userStore = useUserStore()
        // 假设你有一个全局的状态管理器或者Vuex，在这里改变pina的值
        // 如果没有使用Vuex，你也可以在这里直接改变一个全局变量的值
        userStore.serviceStatus = false // 假设你使用的是Vuex并且pina存储在state中

        // 确保要调用 next() 方法，否则钩子就不会被resolved
        next()
    }

})
export default router
